import React from 'react';
import classnames from 'classnames';
import Loading from '$/components/loading/Loading';
import '$/components/global/bixButton/index.scss';

interface IBixFileButtonProps {
  light?: boolean;
  disabled?: boolean;
  useSmall?: boolean;
  multiple?: boolean;
  useLoading?: boolean;
  isLoading?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
}

const BixFileButton: React.FC<IBixFileButtonProps> = props => {
  const { light, disabled, useSmall, multiple, useLoading, isLoading, onChange } = props;
  return (
    <label>
      <input
        type="file"
        multiple={!!multiple}
        disabled={disabled}
        onChange={onChange}
        style={{ display: 'none' }}
        onClick={e => ((e.target as any).value = null)}
      />
      <div
        className={classnames('bix_button bix_file_button', {
          light,
          use_small: useSmall,
          disabled,
          use_loading: useLoading,
        })}>
        {props.children}
        {isLoading && <Loading inline color={light ? 'primary' : 'secondary'} />}
      </div>
    </label>
  );
};

export default BixFileButton;
